import * as v from 'valibot';
import { ProjectTypeSchema } from '@fe-learner-common/api/schemas/sessionsSchema';
import {
  DatesSchema,
  EnrollmentSchema,
  ParticipantInfoSchema,
  PersonSchema,
  SelfEnrollmentProgress,
  SelfEnrollmentStatus,
  WaitlistSchema,
} from '@api/io/session.io';

export const SelfregSessionSchema = v.object({
  id: v.string(),
  bgImage: v.nullish(v.string()),
  selfEnrollmentStatus: v.nullish(SelfEnrollmentStatus),
  selfEnrollmentProgress: v.nullish(SelfEnrollmentProgress),
  selfEnrollmentParticipationUrl: v.nullish(v.string()),
  description: v.nullish(v.string()),
  timezone: v.nullish(v.string()),
  startDate: v.nullish(v.string()),
  endDate: v.nullish(v.string()),
  bgColor: v.nullish(v.string()),
  name: v.nullish(v.string()),
  awardsAvailable: v.boolean(),
  certificatesAvailable: v.boolean(),
  diplomasAvailable: v.boolean(),
  location: v.nullish(v.string()),
  language: v.nullish(v.string()),
  duration: v.nullish(v.number()),
  locale: v.nullish(v.string()),
  format: v.nullish(v.string()),
  version: v.number(),
  trainers: v.nullish(v.array(PersonSchema)),
  participants: v.nullish(v.array(PersonSchema)),
  waitlist: WaitlistSchema,
  enrollment: EnrollmentSchema,
  dates: v.array(DatesSchema),
  participantInfo: v.nullish(ParticipantInfoSchema),
  thumbnailUrl: v.nullish(v.string()),
  projectType: v.nullish(ProjectTypeSchema),
});

export type TSelfregSessionDetails = v.Output<typeof SelfregSessionSchema>;
